import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TDeleteDepositRuleRequestSchema,
  TDeleteDepositRuleResponseSchema,
} from "./deleteDepositRule.schema";

export const deleteDepositRule = (axios: IAxiosInstance) => {
  return async (data: TDeleteDepositRuleRequestSchema) => {
    const { companyID, ruleID } = data;
    const response = await axios.noRetry.delete<
      IApiResponse<TDeleteDepositRuleResponseSchema>
    >(`/api/deposit-rules/${ruleID}`, {
      params: { companyID },
    });

    return response.data;
  };
};
